import _get from 'lodash/get';
import isBadRequest from 'utils/isBadRequest';

const isTokenError = (error) => (
  isBadRequest(error, 400)
  && _get(error, 'error.status') === 'passwords.token'
);

export { isTokenError };
